<template>
    <div class="useronline_body">
        <div style="padding: 20px">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>在线用户</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="padding: 30px">
            <div v-for='item in onlinedata' :key="item">
                <div class="online">
                    <img src="../../assets/computer.png">
                    <div style="display: flex;flex-direction: column">
                        <span>{{item.username}}</span>
                        <span>{{item.ip}}</span>
                    </div>
                    <p>管理员组：{{item.team}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Useronline",
        data(){
            return{
                onlinedata:[]
            }
        },
        mounted() {
            for (let i = 0; i < 2; i++) {
                this.onlinedata.push({
                    username: 'admin',
                    ip: '192.168.100.111',
                    team: '管理员'
                })
            }
        },
        methods:{

        }
    }
</script>

<style scoped>
    .useronline_body {
        min-height: 700px;
    }

    .online {
        float: left;
        width: 164px;
        text-align: center;
        margin-top: 10px;
    }
</style>